import { render, staticRenderFns } from "./GalleryWrapper.vue?vue&type=template&id=5dee5a50&scoped=true"
import script from "./GalleryWrapper.vue?vue&type=script&lang=js"
export * from "./GalleryWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee5a50",
  null
  
)

export default component.exports